import React, { useCallback, useMemo } from "react";

import { retailerTableColumnsConfig } from "./retailerTableColumnsConfig";


import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectRetailerState } from "../../../store/retailer/retailerFilterSlice";
import {
  selectRetailers,
  useGetRetailersListQuery,
} from "../../../services/retailers/retailersApiSlice";
import { CategoryPageSkeleton } from "../../../component/skeleton/CategoryPageSkeleton";
import { Table } from "../../../component/table/Table";


export const RetailerTablePage = ({ data }) => {
  const navigate = useNavigate();
  const appliedFilters = useSelector(selectRetailerState);
  const { isSuccess, isLoading, isFetching } =
    useGetRetailersListQuery(appliedFilters);

  const tableData = useSelector(selectRetailers);

  const handleNavigateToDetail = useCallback(
    (rowData) => {
      console.log(rowData);

      navigate(`${rowData.id}`);
    },

    [navigate],
  );
  const columnDefs = useMemo(
    () => retailerTableColumnsConfig(handleNavigateToDetail),
    [handleNavigateToDetail],
  );

  return isSuccess ? (
    <Table
      data={tableData}
      columns={columnDefs}
      loading={isLoading || isFetching}
    />
  ) : (
    <CategoryPageSkeleton />
  );
};
